export default "__VITE_ASSET__DrnDrF1D__"